import type { PurchaserId } from '@openeducation/oe-rn-shared-types';

import HRPortalSignUpDao from '../dao/hr-portal-sign-up.dao';
import type { Environment } from '../interfaces/environment';

export abstract class HRPortalSignUpService {
  static async signUp(
    env: Environment,
    email: string,
    purchaserId: PurchaserId
  ) {
    if (!purchaserId) {
      throw new Error('No purchaser id provided');
    }
    const data = await HRPortalSignUpDao.signUp(env, email, purchaserId);
    return data;
  }
}
